module.exports = __webpack_public_path__ + "img/max-file-approve--excel.8e3dc902.svg";